import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../store/store';
import { RootState } from '../../reducers';
import { Box, Button, Modal } from '@mui/material';

import { setSelectedMemberId, setShowModal } from '../../store/appointmentScheduler.slice';
import AppointmentScheduler from './AppointmentScheduler';

const AppointmentSchedulerButton: React.FC<{ memberId: string }> = ({ memberId }) => {
    const dispatch = useAppDispatch();
    const { showModal } = useSelector((state: RootState) => state.appointmentScheduler);

    useEffect(() => {
        dispatch(setSelectedMemberId(memberId));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [memberId]);

    return (
        <>
            <Modal open={showModal} onClose={() => dispatch(setShowModal(false))}>
                <Box className="large-modal-box">
                    <AppointmentScheduler />
                </Box>
            </Modal>
            <Button
                variant="contained"
                onClick={() => {
                    dispatch(setShowModal(true));
                }}
            >
                Schedule Optimizer
            </Button>
        </>
    );
};

export default AppointmentSchedulerButton;
